// import mixin from 'react-mixin';

// // @mixin.decorate(window.CssClassMixin)
// // @mixin.decorate(window.InputComponentMixin)
// //@forwardPropsToState([{prop: 'value'}])
// export default class InputMasked extends React.Component {

// 	static propTypes = {
// 		type: React.PropTypes.string,
// 		mask: React.PropTypes.string,
// 		maskType: React.PropTypes.string,
// 		regex: React.PropTypes.string,
// 		autoUnmask: React.PropTypes.bool,
// 		removeMaskOnChange: React.PropTypes.bool,
// 		onComplete: React.PropTypes.func,
// 		onIncomplete: React.PropTypes.func,
// 		onCleared: React.PropTypes.func
// 	}

// 	static defaultProps = {
// 		themeClassKey: 'input.text',
// 		type: 'text',
// 		mask: null,
// 		maskType: null,
// 		regex: null,
// 		autoUnmask: false,
// 		onComplete: function() { },
// 		onIncomplete: function() { },
// 		onCleared: function() { }
// 	}

// 	constructor(props) {
// 		super(props);

// 		this.state = {
// 			placeholder: this.getPlaceholder(),
// 			applyMask: true
// 		}
// 	}

// 	predefinedMasks() {
// 		var localeMasks = Realize.i18n.t("masks");
// 		var predefinedMasks = {};

// 		for(var maskName in localeMasks) {
// 			if(localeMasks.hasOwnProperty(maskName)) {
// 				var mask = localeMasks[maskName];
// 				if(typeof mask == "string") {
// 					predefinedMasks[maskName] = {
// 						mask: mask
// 					}
// 				} else if(typeof mask == "object") {
// 					predefinedMasks[maskName] = mask;
// 				}
// 			}
// 		}

// 		return predefinedMasks;
// 	}

// 	componentDidMount() {
// 		var appliedMask = this.applyMask.call(this);
// 		this.setMaskPlaceholder(appliedMask);
// 	}

// 	componentDidUpdate() {
// 		if(this.state.applyMask) {
// 			this.applyMask.call(this);
// 		}
// 	}

// 	/* input mask functions */

// 	getPlaceholder() {
// 		var placeholder = Realize.i18n.t(this.props.placeholder);
// 		if (typeof placeholder !== "string" || placeholder.length === 0) {
// 			return null;
// 		}

// 		return placeholder;
// 	}

// 	applyMask() {
// 		var appliedMask = {};
// 		if(!!this.props.regex) {
// 			appliedMask = this.applyRegexMask.call(this);
// 		} else {
// 			appliedMask = this.applyBaseMask.call(this);
// 		}

// 		return appliedMask;
// 	}

// 	applyRegexMask() {
// 		var $input = $(this.getInputElement.call(this));
// 		var maskOptions = this.parseMaskOptions.call(this);

// 		$input.inputmask('Regex', maskOptions);
// 		return maskOptions;
// 	}

// 	applyBaseMask() {
// 		var maskType = this.props.maskType;
// 		var predefinedMasks = this.predefinedMasks.call(this);
// 		var predefinedMask = predefinedMasks[maskType];

// 		var appliedMask = {};
// 		if(!!predefinedMask) {
// 			appliedMask = this.applyPredefinedMask.call(this, predefinedMask);
// 		} else {
// 			appliedMask = this.applyCustomMask.call(this);
// 		}

// 		return appliedMask;
// 	}

// 	applyPredefinedMask(predefinedMask) {
// 		var $input = $(this.getInputElement.call(this));
// 		var predefinedMaskOptions = $.extend({}, predefinedMask, this.parseMaskOptions.call(this));

// 		$input.inputmask(predefinedMaskOptions);
// 		return predefinedMaskOptions;
// 	}

// 	applyCustomMask() {
// 		var $input = $(this.getInputElement.call(this));
// 		var maskOptions = this.parseMaskOptions.call(this);

// 		$input.inputmask(maskOptions);
// 		this.setMaskPlaceholder.call(this, maskOptions);
// 		return maskOptions;
// 	}

// 	getInputElement() {
// 		return ReactDOM.findDOMNode(this.refs.input);
// 	}

// 	parseMaskOptions() {
// 		var maskOptions = $.extend({
// 			showMaskOnHover: false,
// 			clearIncomplete: true
// 		}, this.filterMaskOptionProps.call(this));

// 		maskOptions.oncomplete = this.handleComplete.bind(this);
// 		maskOptions.onincomplete = this.handleIncomplete.bind(this);
// 		maskOptions.oncleared = this.props.onCleared.bind(this);

// 		return maskOptions;
// 	}

// 	filterMaskOptionProps() {
// 		var maskOptionProps = {};
// 		var propsToFilter = ['onComplete', 'onIncomplete', 'onCleared'];
// 		for(var propName in this.props) {
// 			if(this.props.hasOwnProperty(propName)) {
// 				var prop = this.props[propName];
// 				if(!!prop && propsToFilter.indexOf(propName) < 0) {
// 					maskOptionProps[propName] = prop;
// 				}
// 			}
// 		}

// 		return maskOptionProps;
// 	}

// 	setMaskPlaceholder(appliedMaskOptions) {
// 		var appliedPlaceholder = appliedMaskOptions.placeholder;

// 		if(!!appliedPlaceholder) {
// 			this.setState({
// 				placeholder: appliedPlaceholder,
// 				applyMask: true
// 			});
// 		}
// 	}

// 	getUnmaskedValue() {
// 		const { value } = this.state;
// 		const $el = $(this.getInputElement.call(this));

// 		return value === undefined || value === null || value === ''
// 		? ''
// 		: $el.inputmask('unmaskedvalue');
// 	}


// 	/* event handlers */

// 	handleComplete(event) {
// 		this.props.onComplete(event);
// 		this.updateValue(event.target.value);
// 	}

// 	handleIncomplete(event) {
// 		this.props.onIncomplete(event);
// 		this.updateValue.call(this, null);
// 	}

// 	handleFocus(event) {
// 		this.props.onFocus(event);

// 		if (this.props.readOnly) {
// 			var inputNode = event.currentTarget;
// 			inputNode.blur();
// 		}
// 	}

// 	handleChange(event) {
// 		var maskedValue = event.target.value
// 		var value = this.props.removeMaskOnChange ? this.getUnmaskedValue.call(this) : maskedValue
// 		this.props.onChange(event, value, this);

// 		if(!event.isDefaultPrevented()) {
// 			this.updateValue.call(this, maskedValue);
// 		}
// 	}

// 	updateValue(value) {
// 		this.setState({
// 			value: value,
// 			applyMask: false
// 		});

// 		console.log(value, typeof value);
// 	}


// 	/* render */

// 	render() {
// 		return (
// 			<input
// 				{...this.props}
// 				yearrange={{ minyear: "0001", maxyear: Infinity }}
// 				value={this.state.value}
// 				placeholder={this.state.placeholder}
// 				onKeyUp={this.handleChange.bind(this)}
// 				onFocus={this.handleFocus.bind(this)}
// 				ref="input">

// 				{this.props.children}
// 			</input>
// 		);
// 	}
// }

// import Inputmask from "inputmask";
// import "inputmask/dist/inputmask/inputmask.extensions";
// import "inputmask/dist/inputmask/inputmask.date.extensions";
// import "inputmask/dist/inputmask/inputmask.numeric.extensions";
// import "inputmask/dist/inputmask/inputmask.phone.extensions";
// import "inputmask/dist/inputmask/inputmask.regex.extensions";

import { forwardPropsToState } from '../../../utils/react_utils';

const RealizeInputMasked = window.InputMasked;

@forwardPropsToState([{prop: 'value'}])
export default class InputMasked extends RealizeInputMasked {

	constructor(props) {
		super(props);
		delete this.getUnmaskedValue;
	}

	getUnmaskedValue() {
		const { value } = this.state;
		const $el = $(this.getInputElement());

		return value === undefined || value === null || value === ''
			? ''
			: $el.inputmask('unmaskedvalue');
	}
}
